export default __webpack_public_path__ + "static/media/yellow.512b61c1.svg";